import React, { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import { DownloadClientsDataInExcel } from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import DragDrop from "../DragDrop/DragDrop";
import { showErrorMessage } from "../Shared/Toast";
function MaterialsListPrice() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);

  const [materialsData, setMaterialsData] = useState<any>([]);

  const [addEditObject, setAddEditObject] = useState({
    mnvmaterialslistpriceid: 0,
    Name: "",
    Description: "",
    CostPerUnit: 0,
    PTOrderBy: 0,
  });

  useEffect(() => {
    MNVMaterialsListPrice();
  }, []);

  function MNVMaterialsListPrice() {
    setIsAnimation(true);
    let object = {} as any;
    object.recordsperpage = 1000;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMaterialsListPrice/MNVMaterialsListPriceGetCompleteGridData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          setMaterialsData(l_oResponse[1]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    let IsOkay = true;
    let Message = "";
    if (addEditObject.Name == "") {
      IsOkay = false;
      Message = "Name required";
    } else if (addEditObject.Description == "") {
      IsOkay = false;
      Message = "Description  required";
    } else if (addEditObject.CostPerUnit == null) {
      IsOkay = false;
      Message = "CostPerUnit required";
    } else if (addEditObject.PTOrderBy == 0) {
      IsOkay = false;
      Message = "PTOrderBy required";
    }

    if (IsOkay) {
      MNVMoverBonusAndDeductionSaveCustom();
    } else {
      showErrorMessage(Message);
    }
  }

  function MNVMoverBonusAndDeductionSaveCustom() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmaterialslistpriceid = addEditObject.mnvmaterialslistpriceid;
    object.name = addEditObject.Name;
    object.description = addEditObject.Description;
    object.costperunit = addEditObject.CostPerUnit;
    object.ptorderby = addEditObject.PTOrderBy;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMaterialsListPrice/MNVMaterialsListPriceSave",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          setIsAddNew(0);
          MNVMaterialsListPrice();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function MNVMaterialsListPriceDeleteRecord(mnvmaterialslistpriceid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmaterialslistpriceid = mnvmaterialslistpriceid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMaterialsListPrice/MNVMaterialsListPriceDeleteRecord",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          // console.log(l_response);
          MNVMaterialsListPrice();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        MNVMaterialsListPriceDeleteRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {isAddNew == 0 && (
        <>
          <>
            <div className="flex-d justify-btw mb-10">
              <div className="flex-da gap-10"></div>
              <div className="flex-daj flex-gap10">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => {
                      setAddEditObject({
                        mnvmaterialslistpriceid: 0,
                        Name: "",
                        Description: "",
                        CostPerUnit: 0,
                        PTOrderBy: 1,
                      });

                      setIsAddNew(1);
                    }}
                  >
                    Add New
                  </a>
                </div>
                <a
                  className="btn-primary flex-daj btn-grid"
                  title="Export"
                  onClick={() =>
                    DownloadClientsDataInExcel("tblemployeebandd", "Materials List Price")
                  }
                >
                  <img src="images/export.svg" width="18" height="18" />
                </a>
              </div>
            </div>

            <table className="reuse-table" id="tblemployeebandd">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Cost Per Unit</th>
                  <th>Order By</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {materialsData &&
                  materialsData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      <tr key={index}>
                        <td>{item.Name}</td>
                        <td>{item.Description}</td>
                        <td>{item.CostPerUnit}</td>
                        <td>{item.PTOrderBy}</td>
                        <td>
                          <div className="flex-daj gap-10">
                            <a
                              onClick={() => {
                                setAddEditObject({
                                  mnvmaterialslistpriceid:
                                    item.MNVMaterialsListPriceID,
                                  Name: item.Name,
                                  Description: item.Description,
                                  CostPerUnit: item.CostPerUnit,
                                  PTOrderBy: item.PTOrderBy,
                                });
                                setIsAddNew(2);
                              }}
                            >
                              <img
                                src="images/edit.svg"
                                width="18px"
                                height="18px"
                                alt="Edit"
                              />
                            </a>
                            <a
                              onClick={() =>
                                globalState.setConfirmationModalObject({
                                  ShowPopup: true,
                                  Heading: "Alert",
                                  Message:
                                    "Are your sure, you want to delete this record?",
                                  ID: 1,
                                  SelectedID: item.MNVMaterialsListPriceID,
                                  OtherID: 0,
                                })
                              }
                            >
                              <img
                                src="images/delete.png"
                                width="18px"
                                height="18px"
                                alt="Delete"
                              />
                            </a>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d">
                <input
                  className="input-field w-100"
                  placeholder="Name"
                  type="text"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d">
                <input
                  className="input-field w-100"
                  placeholder="Description"
                  type="text"
                  value={addEditObject.Description}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Description: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d">
                <input
                  className="input-field w-100"
                  placeholder="Cost Per Unit"
                  type="text"
                  value={addEditObject.CostPerUnit}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,

                      CostPerUnit: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d">
                <input
                  className="input-field w-100"
                  placeholder="Order By"
                  type="text"
                  value={addEditObject.PTOrderBy}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PTOrderBy: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default MaterialsListPrice;
